// extracted by mini-css-extract-plugin
export default {"subLevelsContainer":"styles_subLevelsContainer__kPNBi","subLevelItem":"styles_subLevelItem__ZZBgI","points":"styles_points__24dbE","arrowContainer":"styles_arrowContainer__xIicF"};